import { state } from "./State";
import type * as Types from "./types";

export const clear = (): void => {
  state.tagField.open = false;
  state.deleteDialog.targetTagName = undefined;
  state.tagsMap.clear();
};

export const openTagField = (): void => {
  state.tagField.open = true;
};

export const closeTagField = (): void => {
  state.tagField.open = false;
};

export const updateDeleteDialogTargetTagName = (targetTagName: string): void => {
  state.deleteDialog.targetTagName = targetTagName;
};

export const clearDeleteDialogTargetTagName = (): void => {
  state.deleteDialog.targetTagName = undefined;
};

export const updateTags = (res: Types.TagResponse): void => {
  res?.tags.forEach(tag => {
    state.tagsMap.set(tag.name, tag);
  });
};

export const deleteTag = (tag: Types.TagItem): void => {
  state.tagsMap.delete(tag.name);
};
